import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {isApiResponseOk} from '../../util/utils';

export default function accountMetricsReducer(state = initialstate.accountMetrics, action) {
	switch (action.type) {
		case types.GET_ACCOUNT_METRICS: {
			if (isApiResponseOk(action)) {
				// Using this helper to merge metrics based on include parameters, in order to support
				// several accountMetrics calls in the same section with different include params
				return mergeMetricsResponse(state, action.response, action);
			}
			return state;
		}

		default:
			return state;
	}
}

/**
 * Configuration object mapping include parameters to their corresponding response properties
 * Each key represents an include parameter flag, and the value is an array of property names
 * that should be extracted from the API response when that flag is true.
 */
const METRICS_CONFIG = {
	includeAccountMetric: [
		'countAccountsTestedInThisEngagement',
		'countAccountTypeSignificant',
		'countAccountTypeSignificantDisclosure',
		'countAccountTypeLimitedRisk',
		'countAccountTypeInsignificant',
		'countAccountTypeNotSelected'
	],
	includeRelatedRiskMetric: [
		'countAccountsWithSignificantRisk',
		'countAccountsWithFraudRisk',
		'countAccountsWithHigherInherentRisk',
		'countAccountsWithHigherRisk'
	],
	includeRelatedControlMetric: [
		'countAccountWithControl',
		'countControlWithRelatedAccount',
		'countAccountWithDesignIneffectiveControl',
		'countAccountWithOperateIneffectiveControl',
		'countAccountWithDeficientControl'
	],
	includeRelatedTaskMetric: ['countAccountWithRejectedPSP', 'countAccountSignificantWithOSP'],
	includeStandardRiskMetric: [
		'countAccountHasKnowledgeRisk',
		'countAccountHasAcceptedKnowledgeRisk',
		'countAccountHasRejectedKnowledgeRisk'
	]
};

/**
 * Merges API response metrics into the state based on include parameters
 * @param {Object} state - Current state
 * @param {Object} response - API response containing metrics
 * @param {Object} includeParams - Object with flags indicating which metrics to include
 * @returns {Object} Updated state with merged metrics
 */
function mergeMetricsResponse(state, response, includeParams) {
	if (!includeParams || !response) {
		return state;
	}

	const newState = {};

	// Iterate through the configuration and build the new state
	for (const [paramKey, properties] of Object.entries(METRICS_CONFIG)) {
		if (includeParams[paramKey]) {
			for (const prop of properties) {
				if (Object.prototype.hasOwnProperty.call(response, prop)) {
					newState[prop] = response[prop];
				}
			}
		}
	}

	return {
		...state,
		...newState
	};
}
